/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { PlayerButton } from "./PlayerButton"
import { ToolTip } from "./ToolTip"
import { Spinner } from "./Spinner"

interface IProps {
  tooltip: {
    text: string
    placement: "top" | "top-start" | "top-end"
  }
  button: "settings" | "captions" | "captions-off"
  items: { value: string | number; label: string; loading?: boolean; disabled?: boolean }[]
  onSelect(value: number | string): void
  value: number | string
  open?: boolean
  displayToolTips?: boolean
  setOpen(open: boolean): void
}
export function PlayerMenu({
  tooltip,
  button,
  items,
  onSelect,
  value,
  open,
  setOpen,
  displayToolTips,
}: IProps) {
  function handleClick(value: number | string) {
    onSelect(value)
    setTimeout(() => setOpen(false), 250)
  }
  return (
    <ToolTip
      visible={open}
      content={
        <div>
          {items.map(item => (
            <div
              key={item.value}
              css={css(
                `
                pointer-events: all;
                background-color: #333;
                border-radius: 4px;
                padding: 4px 12px;
                > * { 
                      display:inline-block;
                      vertical-align: middle;
                    }
              `,
                item.disabled && `cursor: not-allowed; opacity: 0.3`,
                item.loading &&
                  `
                    cursor: default; 
                    opacity: 0.5; 
                    
                  `,
                !item.disabled &&
                  !item.loading &&
                  `
                    transition: 0.3s;
                    cursor: pointer;
                    &:hover {
                      background-color: #444;
                    }
                  `,
                value === item.value && `font-weight: bold; color: #36b5f0`,
              )}
              onClick={item.disabled || item.loading ? undefined : () => handleClick(item.value)}
            >
              <span>{item.label}</span>
              {item.loading && (
                <div
                  css={css`
                    position: relative;
                    left: 6px;
                    top: 2px;
                  `}
                >
                  <Spinner size={14} />
                </div>
              )}
            </div>
          ))}
        </div>
      }
      placement="top"
      interactive
    >
      <div>
        <PlayerButton
          onClick={() => setOpen(!open)}
          icon={button}
          tooltip={tooltip}
          displayToolTips={displayToolTips}
        />
      </div>
    </ToolTip>
  )
}
